import { AREA_MASTER } from "constants/areaMaster";

import type { State } from "../useFormState/types/states";

const OTHER_AREA_CODE = AREA_MASTER.others.code;
const OTHER_REQUEST_CODE = "99";

type Input = State["prefectures"];
type Output = string[];
type GetCheckedPrefectureCodeList = (input: Input) => Output;

export const getCheckedPrefectureCodeList: GetCheckedPrefectureCodeList = (
  input
) => {
  const isOtherChecked =
    input.find(({ code }) => code === OTHER_AREA_CODE)?.isAreaChecked ?? false;
  const checkedPrefectureCodeList = input.flatMap((area) => {
    const { prefectures } = area;
    return prefectures.reduce<string[]>((previousValue, prefecture) => {
      const { code, isPrefectureChecked } = prefecture;
      if (!isPrefectureChecked) return previousValue;
      previousValue.push(code);
      return previousValue;
    }, []);
  });

  if (!isOtherChecked) return checkedPrefectureCodeList;

  return [...checkedPrefectureCodeList, OTHER_REQUEST_CODE];
};
